var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"information-card",style:({ backgroundColor: _vm.backgroundColor, width: _vm.width }),on:{"click":function($event){return _vm.informationCard(_vm.cardData)}}},[_c('a',{staticClass:"information-card-title",style:({
      color: _vm.titleFontColor,
      fontSize: _vm.titleFontSize,
      fontWeight: _vm.titleFontWeight,
    }),attrs:{"href":_vm.cardData.href,"target":"_blank","title":_vm.cardData.cardTitle},domProps:{"innerHTML":_vm._s(_vm.processedTitle)}}),_c('span',{staticStyle:{"float":"right"}},[_vm._v(_vm._s(_vm.processedTime))]),_c('div',{staticClass:"information-card-cotent",style:({
      textDecoration: _vm.contentTextDecoration,
      color: _vm.contentFontColor,
      fontSize: _vm.contentFontSize,
      fontWeight: _vm.contentFontWeight,
    }),domProps:{"innerHTML":_vm._s(_vm.processedContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }